import { db } from "@/database/database"
import { Amenity } from "@/database/helpers/tables"

type isAmenityStepFinishedParams = {
  sessionId: string
  amenities: Amenity[]
}

/**
 * Checks in IndexedDB if the amenity step is finished by verifying if all amenities have at least one photo or are marked as skipped.
 * @param params - Object containing sessionId and list of amenities for the step
 * @returns A promise that resolves to true if the step is finished, false otherwise
 */
export async function isAmenityStepFinished(params: isAmenityStepFinishedParams): Promise<boolean> {
  const { sessionId, amenities } = params

  // if there are no amenities, step is not finished
  if (amenities.length === 0) {
    return false
  }

  // check if every amenity has at least one photo
  let hasEveryAmenityPhoto: boolean = true

  for (const amenity of amenities) {
    const photos = await db.photo.findByAmenityId({ sessionId: sessionId, amenityId: amenity.id })

    if (photos.length === 0 && !amenity.skipped) {
      hasEveryAmenityPhoto = false
      break
    }
  }

  // if every amenity has at least one photo, mark step as finished
  if (hasEveryAmenityPhoto) {
    return true
  }

  return false
}
